import { render, staticRenderFns } from "./StudyInspirator.html?vue&type=template&id=e49c9b88&"
import script from "./StudyInspirator.vue?vue&type=script&lang=ts&"
export * from "./StudyInspirator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports